<template>
    <div class="guestflip-item-container">
        <div class="guestflip-item-wrapper" :class="{ 'mb-0': responseSectionExpanded}">

            <div class="d-block d-md-none text-center pt-4">
                <h4 class="header-case">{{ response.survey.title }}</h4>
            </div>

            <div class="row guestflip-item mx-0 pb-1">
                <div class="col-md-4 pl-3">
                    <div class="profile-section">
                        <div class="left"></div>
                        <div class="right">
                            <p class="name mb-0">
                                <strong class="blue-text">{{ guestFullName }}</strong>
                            </p>
                            <p class="name" v-if="response.guest.firstName && response.email">
                                <small>{{ response.email }}</small>
                            </p>
                        </div>
                    </div>

                    <div class="star-rating">
                        <div class="stars-active">
                            <div class="stars" :style="'width:' + response.averageFieldsScore + '%;'">
                                <i class="fa fa-star" v-for="i in scoreOutOf" :key="i"></i>
                            </div>
                        </div>
                        <div class="stars-inactive">
                            <i class="fa fa-star" v-for="i in scoreOutOf" :key="i"></i>
                        </div>
                        <div class="rating-number">{{ score }}/{{ scoreOutOf }}</div>
                    </div>

                    <table class="review-details mt-3">
                        <tbody>
                            <tr v-if="!isAnonymous">
                                <th scope="row">{{ __('Has response') }}</th>
                                <td><span class="score">{{ __(answeredText) }}</span></td>
                            </tr>
                            <tr>
                                <th scope="row">{{ __('Date') }}</th>
                                <td><span class="date"><strong>{{ createdDate }}</strong></span></td>
                            </tr>
                            <tr v-if="response.guest.areaId">
                                <th scope="row">{{ __('Room Number') }}</th>
                                <td><span class="date"><strong>{{ response.guest.areaId }}</strong></span></td>
                            </tr>
                            <tr v-if="!isAnonymous && response.guest.startDate && travelDate">
                                <th scope="row">{{ __('Traveled') }}</th>
                                <td><span class="date">{{ travelDate }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-8">
                    <h4 class="header-case d-none d-md-block">{{ response.survey.title }}</h4>
                </div>

                <template v-if="actionButtons && !responseSectionExpanded">
                    <!-- Desktop Buttons -->
                    <div class="d-none d-md-block">
                        <item-buttons
                            action-type="secondary">
                            <div slot="secondary-buttons" class="d-inline-block">
                                <a v-if="!isAnonymous && !response.answered && response.email" href="#" @click.prevent="openRespondModal(response)" class="action">
                                    {{ __('Respond') }} <i class="fas fa-paper-plane"></i>
                                </a>
                                    <a href="#" @click.prevent="createCase(response.id)" class="action" v-if="spark.state.currentTeam.subscriptions['cases']">
                                        {{ __('CREATE CASE') }} <i class="fas fa-clipboard-list"></i>
                                    </a>
                                <a href="#" @click.prevent="download(response.id)" class="action">
                                    {{ __('Download') }} <i class="fa fa-download"></i>
                                </a>
                                <a href="#" @click.prevent="deleteResponse(response.id)" class="action">
                                    {{ __('Delete') }} <i class="fa fa-trash"></i>
                                </a>
                            </div>
                            <div class="d-inline-block align-middle" slot="primary-button">
                                <a href="#" @click.prevent="preview(response.id)" class="btn btn-primary btn-large">
                                    {{ __('Preview') }} <i class="fas fa-eye"></i>
                                </a>
                            </div>
                        </item-buttons>
                    </div>

                    <!-- Mobile Buttons -->
                    <div class="d-block d-md-none mt-3 mx-3 w-100">
                        <div class="d-flex justify-content-between">
                            <a href="#" @click.prevent="preview(response.id)" class="btn btn-large btn-primary">
                                {{ __('Preview') }} <i class="fas fa-eye"></i>
                            </a>

                            <!-- Dropdown Menu for Actions -->
                            <div class="dropdown" v-if="spark.userPermissions.manage_surveys">
                                <button class="btn btn-large btn-secondary dropdown-toggle" type="button"
                                    id="mobileActionsDropdown" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    {{ __('Actions') }}
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="mobileActionsDropdown">
                                    <a class="dropdown-item" href="#" v-if="response.answered && response.email"
                                        @click.prevent="openResponseModal(response)">
                                        {{ __('Show Response') }} <i class="far fa-clipboard"></i>
                                    </a>
                                    <a class="dropdown-item" href="#"
                                        v-if="!isAnonymous && !response.answered && response.email"
                                        @click.prevent="openRespondModal(response)">
                                        {{ __('Respond') }} <i class="fas fa-paper-plane"></i>
                                    </a>
                                    <a class="dropdown-item" href="#" @click.prevent="download(response.id)">
                                        {{ __('Download') }} <i class="fa fa-download"></i>
                                    </a>
                                    <a class="dropdown-item text-danger" href="#"
                                        @click.prevent="deleteResponse(response.id)">
                                        {{ __('Delete') }} <i class="fa fa-trash"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>

            </div>

            <div class="d-flex justify-content-between px-3 mb-5">
                <div class="cases-toggle" v-if="caseFiles.length">
                    <a
                    href="#"
                    class="blue-link header-case toggle-response d-flex flex-row align-items-center"
                    @click.prevent="toggleCaseFilesExpanded"
                    >
                    <span v-if="caseFilesExpanded">{{ __('Hide Cases') }}</span>
                    <span v-else>{{ __('Show Cases') }}</span>
                    <i :class="['fas', caseFilesExpanded ? 'fa-angle-up' : 'fa-angle-down']"></i>
                    </a>
                </div>
                <div
                    class="response-toggle"
                    v-if="response.answered && response.answer"
                >
                    <div class="d-flex flex-column-reverse flex-md-row align-items-center">
                    <span class="responded-label">
                        {{ __('Responded') }}
                        <i class="fa fa-check pl-1"></i>
                    </span>
                    <a
                        href="#"
                        class="blue-link header-case toggle-response d-flex flex-row align-items-center m-md-2 m-0"
                        @click.prevent="toggleResponseExpanded"
                    >
                        <span v-if="responseExpanded">{{ __('Hide Response') }}</span>
                        <span v-else>{{ __('Show Response') }}</span>
                        <i :class="['fas', responseExpanded ? 'fa-angle-up' : 'fa-angle-down']"></i>
                    </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal gf-modal d-flex justify-content-center align-items-bottom" ref="preview_response_modal" v-if="previewingResponse" tabindex="-1" role="dialog">
            <div class="modal-dialog full-width " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Response preview</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div v-if="currentResponse" class="modal-body">
                        <div v-for="field in currentResponse.fields" class="mb-2" v-if="field.type != 'explanation'">
                            <strong>{{field.title}}</strong>
                            <div v-if="answersOfField(field.id).length">
                                <div v-for="answer in answersOfField(field.id)">
                                    {{answer.textAnswer}}
                                    {{answer.numericAnswer}}
                                </div>
                            </div>
                            <div v-else>
                                N / A
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal gf-modal" ref="respond_response_modal" v-if="writingNewResponse" tabindex="-1" role="dialog">
        <div class="modal-dialog full-width" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Respond to response</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="col-md-12">
                    <surveys-respond-to-guest @responded="completeResponse" :response="currentResponseToRespond" />
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
    
    <div class="modal gf-modal" ref="response_modal" v-if="showingExistingResponse" tabindex="-1" role="dialog">
        <div class="modal-dialog full-width" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Hotel Response</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-if="currentResponseToShow" style="white-space: pre-line">
                    <div v-html="currentResponseToShow.answer"></div>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>

    <!-- Inline Response Block -->
    <div v-if="responseExpanded && response.answer" class="guestflip-review management-response mb-3" :class="{ 'expanded': responseSectionExpanded }">
        <div class="review-section p-0">
            <div class="profile align-items-center">
                <div class="left">{{ spark.state.currentTeam.name.charAt(0).toUpperCase() }}</div>
                <div class="right my-0">
                    <p class="name">{{ spark.state.currentTeam.name }}</p>
                </div>
            </div>
        </div>
        <div class="comment-section p-2">
            <h5 class="header-case">{{ __('Hotel Response') }}</h5>
            <div class="pre-line" v-html="response.answer" style="white-space: pre-line;"></div>
        </div>
    </div>

    <!-- Inline Case Files Block -->
    <div v-if="caseFilesExpanded && caseFiles.length" class="guestflip-review management-response mb-3" :class="{ 'expanded': responseSectionExpanded }">
        <div class="review-section p-0">
            <div class="profile align-items-center">
                <div class="left">{{ spark.state.currentTeam.name.charAt(0).toUpperCase() }}</div>
                <div class="right my-0">
                    <p class="name">{{ spark.state.currentTeam.name }}</p>
                </div>
            </div>
        </div>
        <div class="comment-section p-2">
            <h5 class="header-case">{{ __('Cases') }}</h5>
            <div class="row">
            <div
                v-for="caseFile in caseFiles"
                :key="caseFile.id"
                class="case-item col-md-6 col-12">
                <div
                :class="[
                    'mb-2',
                    'case-header',
                    'case-wrapper',
                    caseFilepriorityStyle(caseFile.priority)
                ]">
                <div class="badges-container d-flex align-items-center mr-2">
                    <span class="badge badge-primary mr-1">{{ caseFile.type }}</span>
                    <span
                    :class="[
                        'badge',
                        caseFileStatusBadge(caseFile.status)
                    ]">
                    {{ caseFile.status }}
                    </span>
                </div>
                <h5 
                    class="header-case blue mb-0 ml-auto text-truncate" 
                    style="max-width: 100%;">
                    <a 
                    href="#" 
                    @click.prevent="viewCase(caseFile.id)" 
                    class="text-primary d-inline-block w-100"
                    data-toggle="tooltip" 
                    :title="caseFile.title">
                    {{ caseFile.title }}
                    </a>
                </h5>
                </div>
            </div>
            </div>
        </div>
    </div>


    </div>
</template>

<script>
import moment from 'moment'
import SurveysService from '../../services/surveys-service'
import SurveysRespondToGuest from './SurveysRespondToGuest';

export default {
    props: {
        response: {
            type: Object,
            required: true
        },
        actionButtons: {
            type: Boolean,
            default: true
        }
    },
    components: {
        SurveysRespondToGuest
    },
    computed: {
        isAnonymous() {
            return this.response.guest.firstName == 'Anonymous' && !this.response.email;
        },
        guestFullName() {
            if (this.isAnonymous) {
                return 'Anonymous'
            }
            return this.response.guest.firstName ? this.response.guest.firstName + ' '
                + this.response.guest.lastName : this.response.email
        },
        score() {
            return this.response.averageFieldsScore / (100 / this.scoreOutOf)
        },
        scoreOutOf() {
            return this.response.outOfFive === 1 ? 5 : 10;
        },
        answeredText() {
            return this.response.answered ? 'Yes' : 'No'
        },
        createdDate() {
            return moment(this.response.createdAt).format("D/M/Y")
        },
        dateResponded() {
            return '29 Jun'
        },
        travelDate() {
            if (moment(this.response.guest.startDate).format("D/M/Y") == 'Invalid date') {
                return null;
            }
            const str = moment(this.response.guest.startDate).format("D/M/Y")
                + ' - '
                + moment(this.response.guest.endDate).format("D/M/Y");
            return str;
        },
        caseFiles() {
            return (this.response.caseFiles || []).map(e => e.caseFile).filter(Boolean);
        },
        responseSectionExpanded() {
            return this.responseExpanded || this.caseFilesExpanded;
        },
    },
    data() {
        return {
            currentResponse: null,
            currentResponseToShow: null,
            currentResponseToRespond: null,
            writingNewResponse: false,
            showingExistingResponse: false,
            previewingResponse: false,
            responseExpanded: false,
            caseFilesExpanded: false,
        }
    },
    methods: {
        answersOfField(fieldId) {
            return this.currentResponse.answers.filter(answer => answer.surveyFieldId === fieldId);
        },
        openRespondModal(response) {
            this.currentResponseToRespond = response
            this.respondMessage = ''
            this.writingNewResponse = true;
            const that = this;
            this.$nextTick(function () {
                $(that.$refs.respond_response_modal).modal('toggle')
                $(that.$refs.respond_response_modal).on('hidden.bs.modal', function (e) {
                    that.writingNewResponse = false;
                });
            });
        },
        completeResponse() {
            $(this.$refs.respond_response_modal).modal('hide');
            this.response.answered = 1;
        },
        openResponseModal(response) {
            this.showingExistingResponse = true;
            this.currentResponseToShow = response
            const that = this;
            this.$nextTick(function () {
                $(this.$refs.response_modal).modal('toggle')
                $(that.$refs.response_modal).on('hidden.bs.modal', function (e) {
                    that.writingNewResponse = false;
                });
            });
        },

        async preview(responseId) {
            const data = await SurveysService.responses.get(responseId)
            this.currentResponse = data
            this.previewingResponse = true;
            const that = this;
            this.$nextTick(function() {
                $(that.$refs.preview_response_modal).modal('toggle')
                $(that.$refs.preview_response_modal).on('hidden.bs.modal', function (e) {
                    that.previewingResponse = false;
                });
            });
        },

        async download(responseId) {
            const data = await SurveysService.reports.download(responseId)

            if (data.error) {
                swal({
                    title: 'Could not download report',
                    text: data.error,
                    type: 'warning',
                    showCloseButton: true,
                    timer: 10000
                })
            }
        },

        async deleteResponse(responseId) {
            const data = await SurveysService.responses.delete(responseId)

            if (data.error) {
                swal({
                    title: 'Could not download report',
                    text: data.error,
                    type: 'warning',
                    showCloseButton: true,
                    timer: 10000
                })
            } else {
                swal({
                    title: 'Response Deleted',
                    text: data.data,
                    type: 'success',
                    showCloseButton: true,
                    timer: 40000
                })

                this.$nextTick(function () {
                    this.$destroy();
                    this.$el.parentNode.removeChild(this.$el);
                });
            }
        },

        createCase() {
            const url = `/cases?surveyResponseId=${this.response.id}#case-create`;
            window.location.replace(url);
        },

        caseFileStatusBadge(status) {
            switch (status.toLowerCase()) {
                case 'open':
                    return 'badge-success';
                case 'closed':
                    return 'badge-danger';
                case 'pending':
                    return 'badge-warning';
                default:
                    return 'badge-secondary'; 
            }
        },
        caseFilepriorityStyle(priority) {
            const priorities = {
                0: 'low-priority',
                1: 'medium-priority',
                2: 'high-priority',
            };

            return priorities[priority] || '';
        },

        toggleCaseFilesExpanded() {
            this.caseFilesExpanded = !this.caseFilesExpanded;
            if (this.caseFilesExpanded) this.responseExpanded = false
        },
        toggleResponseExpanded() {
            this.responseExpanded = !this.responseExpanded;
            if (this.responseExpanded) this.caseFilesExpanded = false
        },

        viewCase(caseId) {
            const url = `/cases?caseId=${caseId}#cases-view`;
            window.location.href = url;
        },
    }
}
</script>